import { AbstractControl, FormControl, Validators, FormGroup } from '@angular/forms';
import { User } from './user.schema';
import { Vehicle } from './vehicle.schema';
import { phoneValid } from '../helpers/validators/phone.validator';

export class Operation {
    public static validation(profile = false): { [key: string]: AbstractControl } {
        let validator: { [key: string]: AbstractControl } = {
            phone: new FormControl('', Validators.compose([Validators.required, phoneValid()])),
            address: new FormControl('', Validators.required),
            longitude: new FormControl(''),
            latitude: new FormControl(''),
            notes: new FormControl(''),
            receiveEmailMsg: new FormControl(true),
            receiveWhatsappMsg: new FormControl(true),
            isProjectManager: new FormControl(true),
        };
        validator['user'] = profile ?
            new FormGroup({ ...User.specificValidation(), ...User.editLoginValidation() }) :
            new FormGroup(User.specificValidation());
        return validator;
    }

    public static readonly validationMessages = {
        'phone': [
            { type: 'required', message: 'Obbligatorio' },
            { type: 'phone', message: 'Formato invalido. Deve contenere fra le 10 e le 14 cifre' }
        ],
        'address': [{ type: 'required', message: 'Obbligatorio' }],
        'user': User.validationMessages
    };

    constructor(
        public id?: number,
        public phone?: string,
        public address?: string,
        public longitude?: string,
        public latitude?: string,
        public notes?: string,
        public user?: User,
        public receiveEmailMsg?: boolean,
        public receiveWhatsappMsg?: boolean,
        public isProjectManager?: boolean,
    ) { }
}